import reducer from './redux';

export default reducer;
